// View Component: Ana landing page bileşeni
import React from 'react';
import Navbar from './sections/Navbar';
import Hero from './sections/Hero';
import Features from './sections/Features';
import Testimonials from './sections/Testimonials';
import Contact from './sections/Contact';
import Footer from './sections/Footer';

const LandingPage = () => {
  return (
    <div>
      {/* Navbar - Fixed position */}
      <Navbar />
      
      {/* Ana İçerik */}
      <main>
        {/* Hero Bölümü */}
        <Hero />
        
        {/* Features Section */}
        <Features />
        
        {/* Testimonials */}
        <Testimonials />
        
        {/* Contact Section */}
        <Contact />
      </main>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default LandingPage; 